module.exports = __webpack_public_path__ + "img/multiple-devices-mobile.1a40c949.png";